module.exports = __webpack_public_path__ + "static/media/VarunS.d2729840.webp";